import { useNavigate } from "react-router-dom";
import Header from "../../components/Header/Header";
import { FaFacebook, FaInstagram, FaTiktok, FaTwitter } from "react-icons/fa";
import Powerdby from "../../assets/poweredby.png";
import { TiMail } from "react-icons/ti";
import { HiOutlineLocationMarker } from "react-icons/hi";
import { BiSupport } from "react-icons/bi";
import { BsTelephone } from "react-icons/bs";
import Footer from "../../components/Footer/Footer";


function TokenExpire() {
    const navigate = useNavigate();
    let data = new URLSearchParams(window.location.search).get("data");
    console.log(data, "data");

    const currentUser: any = JSON.parse(localStorage.getItem("user") || "{}");
    const userToken: string = currentUser?.jwtToken;
    return (
        <div className="overscroll-x-none">
            <div className="h-[75px] z-20 fixed mx-10 ">
                <Header position={"fixed"} isLoggedIn={userToken ? true : false} />
            </div>

            <div className="mx-[200px] my-[150px] ">
                <div

                >
                    <div className="justify-between items-center flex flex-col  ">
                        <h5 className="text-3xl pt-4  mr-8 ml-8 mb-8 text-red-500 font-bold">
                            {data == 'sessionExpire' ? 'Session Expire' : 'Technical Error'}
                        </h5>
                        <h5 className="text-xl pt-1 mr-8 ml-8">
                            {data == 'sessionExpire' ? 'Your session has been expired.' : ' We are experiencing some technical error. '}
                        </h5>
                        <div
                            className="justify-center items-center flex p-1 flex-col lg:flex-row"
                        >

                            <span
                                className=" text-xl text-blue-700 cursor-pointer"
                                onClick={() => {
                                    navigate("/profile/auth/login");
                                }}
                            >
                                Click here{""}
                            </span>
                            &nbsp;
                            <p className="text-xl ">to login again {data == 'sessionExpire'?"":"or try after sometime"} </p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="mt-[470px]">
                <Footer />

            </div>

        </div>
    );
}

export default TokenExpire;
